import {getTmdbImage} from "../../../../../../utils/consts";
import {useNavigate} from "react-router-dom";
import {isSmallMediumScreen, isSmallScreen} from "../../../../../../utils/utils";
import cap17drive from "../../../../index";
import {useDispatch} from "react-redux";
import {useMemo} from "react";

function EpisodeResultCard({
                               episode,
                               nextEpisodeInfo,
                               nextInfoText = "Siguiente",
                               customOnClick,
                               forceSmall,
                               forceBig,
                               selected,
                               showImageSpoiler = false,
                               showSpoiler = false
                           }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isSmallFormat = () => (isSmallMediumScreen() || forceSmall) && !forceBig;

    const colSize = () => (isSmallFormat() ? 2 : 3);

    const playStatus = useMemo(() => {
        if (episode.can_play) {
            return "playable"
        }
        if (episode.downloading) {
            return "downloading"
        }
        return "not-playable"
    }, [episode.can_play, episode.downloading]);

    return (
        <div className={"card mb-3 tmdb-result-card " + (selected ? 'border-success text-success' : '')}
             style={{maxHeight: "100px", overflow: "hidden"}}
             onClick={e => {
                 if (customOnClick) {
                     customOnClick();
                     return;
                 }
                 if (!selected) {
                     dispatch(cap17drive.actions.clearSelectedEpisode());
                     navigate('/squadflix/series/' + episode.show_id + '/' + episode.season_number + '/' + episode.episode_number);
                 }
             }}>
            <div className="d-flex flex-row">
                <div>
                    {!isSmallFormat() &&
                        <img style={{
                            maxHeight: "100px",
                            filter: (episode.view || showSpoiler || showImageSpoiler) ? "blur(0)" : "blur(8px)",
                            aspectRatio: "16/9",
                            objectFit: "cover"
                        }}
                             src={getTmdbImage(episode['still_path'], "w200")}
                             alt={episode.episode_number}
                             className="img-fluid rounded-start"/>}
                    {isSmallFormat() &&
                        <div className="ps-2 d-flex flex-row h-100 align-items-center">
                            {playStatus === "downloading" &&
                                <i className="fa-regular fa-circle fa-beat-fade fa-2xl"></i>}
                            {playStatus === "playable" && <i className="fa-regular fa-circle-play fa-2xl"></i>}
                            {playStatus === "not-playable" && <i className="fa-regular fa-circle fa-2xl"></i>}
                        </div>}
                </div>
                <div className="fw-bold w-100">
                    <div className="card-body ps-3 pt-0 pe-0 pb-0">
                        <div className="card-title mb-1 d-flex flex-row justify-content-between">
                            {nextEpisodeInfo && `${nextInfoText ? nextInfoText + ":" : ''} T${episode.season_number} `} {isSmallScreen() ? "E" : "Episodio "}{episode.episode_number}
                            <div className="me-2 d-flex flex-row align-items-center gap-2">
                                {
                                    episode.has_notes &&
                                    <i className="fa-regular fa-note-sticky"></i>
                                }
                                {episode.view ? <i className="fa-solid fa-check-double"></i> : ''}
                                {!isSmallFormat() &&
                                    <>
                                        {episode.can_play ?
                                            <i className="fa-regular fa-circle-play"></i> :
                                            <i className="fa-regular fa-circle"></i>}
                                    </>
                                }
                            </div>
                        </div>
                        <span
                            className="card-title text-muted">{(episode.view || showSpoiler) ? episode.name : "No visto"}</span>
                    </div>
                </div>
            </div>
        </div>
    )
        ;
}

export default EpisodeResultCard;
